export default __webpack_public_path__ + "static/media/visa.9f90e11e.png";